export default __webpack_public_path__ + "static/media/joke-sphere.frag.863e3570.glsl";